import { ClaimItemDTO, ClaimItemCorrectionResponseDTO } from '@reposit/api-client';

import {
  DiscardClaimItemPayload,
  UpdateClaimItemPayload,
  CreateClaimItemPayload,
  InternalUpdateClaimItemPayload,
  PreviewClaimItemUpdatePayload,
  PendingInternalUpdate,
} from './claim-item.types';

export const CREATE_CLAIM_ITEM_STORE_KEY = `CLAIM/CREATE_CLAIM_ITEM`;
export const CREATE_CLAIM_ITEM_API_REQUESTED = `CLAIM/CREATE_CLAIM_ITEM_API_REQUESTED`;
export const CREATE_CLAIM_ITEM_API_SUCCESS = `CLAIM/CREATE_CLAIM_ITEM_API_SUCCESS`;
export const CREATE_CLAIM_ITEM_API_FAILED = `CLAIM/CREATE_CLAIM_ITEM_API_FAILED`;

export const UPDATE_CLAIM_ITEM_STORE_KEY = `CLAIM/UPDATE_CLAIM_ITEM`;
export const UPDATE_CLAIM_ITEM_API_REQUESTED = `CLAIM/UPDATE_CLAIM_ITEM_API_REQUESTED`;
export const UPDATE_CLAIM_ITEM_API_SUCCESS = `CLAIM/UPDATE_CLAIM_ITEM_API_SUCCESS`;
export const UPDATE_CLAIM_ITEM_API_FAILED = `CLAIM/UPDATE_CLAIM_ITEM_API_FAILED`;

export const DISCARD_CLAIM_ITEM_STORE_KEY = `CLAIM/DISCARD_CLAIM_ITEM`;
export const DISCARD_CLAIM_ITEM_API_REQUESTED = `CLAIM/DISCARD_CLAIM_ITEM_API_REQUESTED`;
export const DISCARD_CLAIM_ITEM_API_SUCCESS = `CLAIM/DISCARD_CLAIM_ITEM_API_SUCCESS`;
export const DISCARD_CLAIM_ITEM_API_FAILED = `CLAIM/DISCARD_CLAIM_ITEM_API_FAILED`;

export const INTERNAL_UPDATE_CLAIM_ITEM_STORE_KEY = `CLAIM/INTERNAL_UPDATE_CLAIM_ITEM`;
export const INTERNAL_UPDATE_CLAIM_ITEM_API_REQUESTED = `CLAIM/INTERNAL_UPDATE_CLAIM_ITEM_API_REQUESTED`;
export const INTERNAL_UPDATE_CLAIM_ITEM_API_SUCCESS = `CLAIM/INTERNAL_UPDATE_CLAIM_ITEM_API_SUCCESS`;
export const INTERNAL_UPDATE_CLAIM_ITEM_API_FAILED = `CLAIM/INTERNAL_UPDATE_CLAIM_ITEM_API_FAILED`;

export const PREVIEW_CLAIM_ITEM_UPDATE_STORE_KEY = `CLAIM/PREVIEW_CLAIM_ITEM_UPDATE`;
export const PREVIEW_CLAIM_ITEM_UPDATE_API_REQUESTED = `CLAIM/PREVIEW_CLAIM_ITEM_UPDATE_API_REQUESTED`;
export const PREVIEW_CLAIM_ITEM_UPDATE_API_SUCCESS = `CLAIM/PREVIEW_CLAIM_ITEM_UPDATE_API_SUCCESS`;
export const PREVIEW_CLAIM_ITEM_UPDATE_API_FAILED = `CLAIM/PREVIEW_CLAIM_ITEM_UPDATE_API_FAILED`;
export const CLEAR_CLAIM_ITEM_PREVIEW = `CLAIM/CLEAR_CLAIM_ITEM_PREVIEW`;

/* -------------------------------------------- CREATE CLAIM ITEM -------------------------------------------- */
export function createClaimItemRequested(payload: CreateClaimItemPayload) {
  return {
    type: CREATE_CLAIM_ITEM_API_REQUESTED,
    payload
  } as const;
}
export function createClaimItemSuccess(payload: ClaimItemDTO) {
  return {
    type: CREATE_CLAIM_ITEM_API_SUCCESS,
    payload
  } as const;
}
export function createClaimItemFailed(error: string) {
  return {
    type: CREATE_CLAIM_ITEM_API_FAILED,
    payload: error
  } as const;
}

/* -------------------------------------------- UPDATE CLAIM ITEM -------------------------------------------- */
export function updateClaimItemRequested(payload: UpdateClaimItemPayload) {
  return {
    type: UPDATE_CLAIM_ITEM_API_REQUESTED,
    payload
  } as const;
}
export function updateClaimItemSuccess(payload: ClaimItemDTO) {
  return {
    type: UPDATE_CLAIM_ITEM_API_SUCCESS,
    payload
  } as const;
}
export function updateClaimItemFailed(error: string) {
  return {
    type: UPDATE_CLAIM_ITEM_API_FAILED,
    payload: error
  } as const;
}

/* ---------------------------------------- INTERNAL UPDATE CLAIM ITEM ---------------------------------------- */
export function internalUpdateClaimItemRequested(payload: InternalUpdateClaimItemPayload) {
  return {
    type: INTERNAL_UPDATE_CLAIM_ITEM_API_REQUESTED,
    payload
  } as const;
}
export function internalUpdateClaimItemSuccess(payload: ClaimItemCorrectionResponseDTO) {
  return {
    type: INTERNAL_UPDATE_CLAIM_ITEM_API_SUCCESS,
    payload
  } as const;
}
export function internalUpdateClaimItemFailed(error: string) {
  return {
    type: INTERNAL_UPDATE_CLAIM_ITEM_API_FAILED,
    payload: error
  } as const;
}

/* ------------------------------------------ PREVIEW CLAIM ITEM UPDATE ------------------------------------------ */
export function previewClaimItemUpdateRequested(payload: PreviewClaimItemUpdatePayload) {
  return {
    type: PREVIEW_CLAIM_ITEM_UPDATE_API_REQUESTED,
    payload
  } as const;
}
export function previewClaimItemUpdateSuccess(payload: PendingInternalUpdate) {
  return {
    type: PREVIEW_CLAIM_ITEM_UPDATE_API_SUCCESS,
    payload
  } as const;
}
export function previewClaimItemUpdateFailed(error: string) {
  return {
    type: PREVIEW_CLAIM_ITEM_UPDATE_API_FAILED,
    payload: error
  } as const;
}
export function clearClaimItemPreview() {
  return { type: CLEAR_CLAIM_ITEM_PREVIEW } as const;
}

/* -------------------------------------------- DISCARD CLAIM ITEM -------------------------------------------- */
export function discardClaimItemRequested(payload: DiscardClaimItemPayload) {
  return {
    type: DISCARD_CLAIM_ITEM_API_REQUESTED,
    payload
  } as const;
}
export function discardClaimItemSuccess(payload: DiscardClaimItemPayload) {
  return {
    type: DISCARD_CLAIM_ITEM_API_SUCCESS,
    payload
  } as const;
}
export function discardClaimItemFailed(error: string) {
  return {
    type: DISCARD_CLAIM_ITEM_API_FAILED,
    payload: error
  } as const;
}

export type ClaimItemActionTypes = ReturnType<
  | typeof createClaimItemRequested
  | typeof createClaimItemSuccess
  | typeof createClaimItemFailed
  | typeof updateClaimItemRequested
  | typeof updateClaimItemSuccess
  | typeof updateClaimItemFailed
  | typeof internalUpdateClaimItemRequested
  | typeof internalUpdateClaimItemSuccess
  | typeof internalUpdateClaimItemFailed
  | typeof previewClaimItemUpdateRequested
  | typeof previewClaimItemUpdateSuccess
  | typeof previewClaimItemUpdateFailed
  | typeof clearClaimItemPreview
  | typeof discardClaimItemRequested
  | typeof discardClaimItemSuccess
  | typeof discardClaimItemFailed
>;
